<template>
  <v-navigation-drawer
    :mini-variant-width="70"
    app
    :permanent="!isMobile"
    :expand-on-hover="!isMobile"
    v-model="isMenuOpen"
    :style="styleNavegator"
  >
    <v-list class="px-2">
      <v-list-item
        v-for="(menu, i) in menus"
        :key="'menu-professor-' + i"
        @click="onClickFunction(menu)"
        class="white--text"
        :class="{
          'lista--ativa': rotaAtiva(menu.rota),
          'mb-3': menu.titulo === 'Livros',
          'menu-meu-perfil': menu.titulo === 'Meu Perfil',
        }"
      >
        <v-list-item-icon class="d-flex align-center justify-center mx-0 my-2">
          <v-img max-width="30" max-height="30" :src="menu.icon"/>
          <div v-if="menu.titulo === 'Livros'" class="divisor"/>
        </v-list-item-icon>

        <v-list-item-title class="ms-5" :style="{ whiteSpace: 'normal' }">
          {{ menu.titulo }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
    <ModalSair
      :modal-aberto="modalSairAberto"
      @close-modal="modalSairAberto = false"
      @sair="sairSistema"
      @continuar="modalSairAberto = false"
    />
  </v-navigation-drawer>
</template>

<script>
import ModalSair from "@/components/ModalSair.vue";

export default {
  name: "NavbarOperador",
  props: ["toggleMenu"],
  components: { ModalSair },
  data() {
    return {
      isMenuOpen: false,
      modalSairAberto: false,
      menus: [
        {
          titulo: "Gerador de questão por IA",
          icon: "/assets/icones/questao-ia.png",
          rota: "/operador/questao-por-ia",
        },
        {
          titulo: "Sair",
          icon: "/assets/icones/menu-sair.svg",
          rota: "sair",
          onClickFunction: () => {
            this.modalSairAberto = true
          },
        },
      ],
    };
  },
  methods: {
    sairSistema() {
      this.modalSairAberto = false;
      this.$router.push('/sair');
    },
    rotaAtiva(rota) {
      return this.$route.fullPath.indexOf(rota) !== -1;
    },
    onClickFunction(menu) {
      if (menu.onClickFunction) {
        menu.onClickFunction();
      } else {
        this.clickAcaoMenu(menu);
      }
    },
    clickAcaoMenu(menu) {
      if (menu.rota == this.$router.currentRoute.path) {
        return;
      }
      if (menu.rota != "#") {
        this.$router.push(menu.rota);
      } else {
        this.modalPaginaConstrucaoAberto = true;
      }
    },
  },
  watch: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width <= 600;
    },
    styleNavegator() {
      return { 
        background: 'var(--main-color)', 
        height: '100%' 
      }
    },
  },
};
</script>
